/**
 * Description: math
 */
import * as R from 'ramda'

const getPrecision = (a = 0) => ((a.toString().split('.')[1] || []).length)

const _mul = (a, b) => {
  const snReg = /[eE]+/
  const d = a.toString()
  const e = b.toString()
  if (snReg.test(d) || snReg.test(e)) {
    return a * b
  }

  let c = 0
  c += getPrecision(d)
  c += getPrecision(e)
  return Number(d.replace('.', '')) * Number(e.replace('.', '')) / 10 ** c
}

const _sub = (a, b) => {
  const c = getPrecision(a)
  const d = getPrecision(b)
  const e = 10 ** Math.max(c, d)
  return (_mul(a, e) - _mul(b, e)) / e
}

const _div = (a, b) => {
  let e = 0
  let f = 0
  try {
    e = getPrecision(a)
    f = getPrecision(b)
  } catch (g) {
    // console.error(g)
  }
  const c = Number(a.toString().replace('.', ''))
  const d = Number(b.toString().replace('.', ''))
  return _mul((c / d), 10 ** (f - e))
}

const _add = (a, b) => {
  const c = getPrecision(a)
  const d = getPrecision(b)
  const e = 10 ** Math.max(c, d)
  return (_mul(a, e) + _mul(b, e)) / e
}

const isEven = R.pipe(R.length, R.modulo(R.__, 2), R.equals(0))

const completeWith = x => R.ifElse(isEven, R.identity, R.append(x))

const isNothing = R.either(R.isNil, R.isEmpty)

const correctNumberArgs = (act, right) => R.pipe(
  R.pair,
  R.map(R.ifElse(isNothing, R.always(right), R.identity)),
  R.apply(act),
)

const processWithAcc = (acc, act) => R.unapply(
  R.pipe(
    completeWith(acc),
    R.splitEvery(2),
    R.reduce(R.useWith(act, [R.identity, R.apply(act)]), acc),
  ),
)

export const mul2 = R.curryN(2, correctNumberArgs(_mul, 1))

export const mul = processWithAcc(1, correctNumberArgs(_mul, 1))

export const add = processWithAcc(0, correctNumberArgs(_add, 0))

export const sub = R.curryN(2, correctNumberArgs(_sub, 0))

export const div = R.curryN(2, correctNumberArgs(_div, 1))
